export default "__VITE_ASSET__IrRgSv5y__"